<template>
    <div class="statistic-container">
        <!-- 顾客信息统计 - 占40% -->
        <div class="customer-section">
            <div class="section-header">
                <div class="header-line"></div>
                <span class="section-title">门店顾客统计</span>
            </div>
            <div class="statistic-grid customer-grid">
                <div class="statistic-card" v-for="(item, index) in customerItems" :key="index">
                    <el-tooltip :content="item.tooltip || ''" placement="top" :disabled="!item.tooltip" effect="dark">
                        <div class="card-wrapper">
                            <div class="card-icon" :style="{ background: item.bgColor }">
                                <img src="@/assets/img/numStatistic.png" />
                            </div>
                            <div class="card-content">
                                <div class="card-label">{{ item.label }}</div>
                                <div class="card-value">{{ item.value }}</div>
                            </div>
                        </div>
                    </el-tooltip>
                </div>
            </div>
        </div>

        <!-- 销售订单统计 - 占60% -->
        <div class="sales-section">
            <div class="section-header">
                <div class="header-line"></div>
                <span class="section-title">销售订单统计</span>
            </div>
            <div class="statistic-grid sales-grid">
                <div class="statistic-card" v-for="(item, index) in salesItems" :key="index">
                    <div class="card-wrapper">
                        <div class="card-icon" :style="{ background: item.bgColor }">
                            <img src="@/assets/img/numStatistic.png" />
                        </div>
                        <div class="card-content">
                            <div class="card-label">{{ item.label }}</div>
                            <div class="card-value">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GetCustomerInfoStatistic } from "@/api/baseDataApi.js";
import { GetSalesOrderNumStatistic } from "@/api/productApi.js";
export default {
    data() {
        return {
            loading: false,
            customerStatisticData: {
                dayCount: 0,
                finishedCreateCommissionCount: 0,
                hasCommissionCount: 0,
                monthCount: 0,
                totalCount: 0,
                vipCount: 0,
            },
            salesOrderStatisticData: {
                daySalesOrderMoney: 0,
                daySalesOrderNum: 0,
                monthSalesOrderMoney: 0,
                monthSalesOrderNum: 0,
                qianKuanMoney: 0,
                qianKuanSalesOrderNum: 0,
                salesOrderNum: 0,
                unConfirmSalesOrderNum: 0,
            },
        };
    },
    computed: {
        customerItems() {
            return [
                { label: "今日顾客", value: this.customerStatisticData.dayCount, bgColor: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)", tooltip: "" },
                { label: "本月顾客", value: this.customerStatisticData.monthCount, bgColor: "linear-gradient(135deg, #1a96c7 0%, #1479a3 100%)", tooltip: "" },
                { label: "顾客总数", value: this.customerStatisticData.totalCount, bgColor: "linear-gradient(135deg, #1eda3d 0%, #17b030 100%)", tooltip: "" },
                { label: "电话邀约", value: this.customerStatisticData.hasCommissionCount || 0, bgColor: "linear-gradient(135deg, #ca4545 0%, #a83838 100%)", tooltip: "" },
                { label: "已创建提成", value: this.customerStatisticData.finishedCreateCommissionCount || 0, bgColor: "linear-gradient(135deg, #dd912c 0%, #bf7a24 100%)", tooltip: "电话邀约进店的并且已经创建跑单提成或进店成交提成的顾客数量" },
                { label: "会员总数", value: this.customerStatisticData.vipCount, bgColor: "linear-gradient(135deg, #8736e4 0%, #6b2db0 100%)", tooltip: "" },
            ];
        },
        salesItems() {
            return [
                { label: "今日订单", value: this.salesOrderStatisticData.daySalesOrderNum, bgColor: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)" },
                { label: "本月订单", value: this.salesOrderStatisticData.monthSalesOrderNum, bgColor: "linear-gradient(135deg, #1a96c7 0%, #1479a3 100%)" },
                { label: "订单总数", value: this.salesOrderStatisticData.salesOrderNum, bgColor: "linear-gradient(135deg, #ca4545 0%, #a83838 100%)" },
                { label: "欠款订单", value: this.salesOrderStatisticData.qianKuanSalesOrderNum, bgColor: "linear-gradient(135deg, #dd912c 0%, #bf7a24 100%)" },
                { label: "未确认订单", value: this.salesOrderStatisticData.unConfirmSalesOrderNum || 0, bgColor: "linear-gradient(135deg, #dd912c 0%, #bf7a24 100%)" },
                { label: "今日销售额", value: "¥" + this.salesOrderStatisticData.daySalesOrderMoney, bgColor: "linear-gradient(135deg, #1eda3d 0%, #17b030 100%)" },
                { label: "本月销售额", value: "¥" + this.salesOrderStatisticData.monthSalesOrderMoney, bgColor: "linear-gradient(135deg, #8736e4 0%, #6b2db0 100%)" },
                { label: "欠款金额", value: "¥" + this.salesOrderStatisticData.qianKuanMoney, bgColor: "linear-gradient(135deg, #ca4545 0%, #a83838 100%)" },
            ];
        },
    },
    components: {},

    created() {
        this.GetCustomerInfoStatistic();
        this.GetSalesOrderNumStatistic();
    },

    mounted() { },

    methods: {
        GetCustomerInfoStatistic() {
            let param = {};
            GetCustomerInfoStatistic(param).then((res) => {
                if (res.code == 1) {
                    this.loading = false;
                    this.customerStatisticData = res.data;
                } else {
                    this.$message({
                        type: "info",
                        message: res.msg,
                    });
                }
            });
        },
        GetSalesOrderNumStatistic() {
            let param = {};
            GetSalesOrderNumStatistic(param).then((res) => {
                if (res.code == 1) {
                    this.loading = false;
                    this.salesOrderStatisticData = res.data;
                } else {
                    this.$message({
                        type: "info",
                        message: res.msg,
                    });
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.statistic-container {
    display: flex;
    gap: 16px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.customer-section {
    flex: 2;
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.sales-section {
    flex: 3;
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
}

.header-line {
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, #409eff 0%, #67c23a 100%);
    border-radius: 2px;
    margin-right: 12px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    letter-spacing: 0.5px;
}

.statistic-grid {
    display: grid;
    gap: 12px;
}

.customer-grid {
    grid-template-columns: repeat(3, 1fr);
}

.sales-grid {
    grid-template-columns: repeat(4, 1fr);
}

.statistic-card {
    display: flex;
    align-items: center;

    .card-wrapper {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 12px;
        background: linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%);
        border-radius: 8px;
        transition: all 0.3s ease;
        border: 1px solid #e2e8f0;
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 24px rgba(64, 158, 255, 0.15);
            border-color: #409eff;
        }
    }
}

.card-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    img {
        width: 28px;
        height: 28px;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }
}

.card-content {
    margin-left: 12px;
    flex: 1;
    min-width: 0;
}

.card-label {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-value {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    font-family: "Helvetica Neue", Arial, sans-serif;
}

@media (max-width: 1400px) {
    .customer-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .sales-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 1200px) {
    .statistic-container {
        flex-direction: column;
    }

    .customer-section,
    .sales-section {
        flex: 1;
    }

    .customer-grid,
    .sales-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .customer-grid,
    .sales-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
